let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eWzXf"), load("ffEVr"), load("7owaE")]).then(() => parcelRequire('dTP2L'));